import numeral from 'numeral'
/**
 * 把20190312转为2019/03/12
 */
export function fmtData(date: string, sign = '/'): string {
  return `${date.slice(0, 4)}${sign}${date.slice(4, 6)}${sign}${date.slice(
    6,
    8,
  )}`
}

export function formatDollar(v: number, sign = '$'): string {
  return numeral(v).format(`${sign}0,0[.]00`)
}
